import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import { SketchPicker } from "@hello-pangea/color-picker";

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState({})
	const [selectedItem, setSelectedItem] = useState({ 'color': 'var(--dark-text-strong, #000000)', 'coefficient': '100', 'is_present': true })
	const [showModal, setShowModal] = useState(false)

	const colorRef = useRef(null);

	async function searchWithFilter() {
		var filterUrl = "/users-attendances-types"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/users-attendances-types', selectedItem, { loader: true })
		} else {
			response = await POST('/users-attendances-types', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	function handleInputChange(key, value) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[key] = value
		setSelectedItem(selectedItemCopy)
	}

	function handleChangeColor(color) {
		handleInputChange('color', color.hex)
	};

	function toggleModal(bool = false, item = { 'color': 'var(--dark-text-strong, #000000)', 'coefficient': '100', 'is_present': true }) {
		setSelectedItem(item)
		setShowModal(bool)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('attendances_types')}
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('short_name')}</th>
									<th style={{ 'width': '10%' }}>{t('coefficient')}</th>
									<th style={{ 'width': '30%' }}>{t('note')}</th>
									<th style={{ 'width': '20%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td>{item.short_name}</td>
										<td>{item.coefficient}</td>
										<td>{item.note}</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ""}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('short_name')}</label>
							<input type="text" className="form-control" name="short_name"
								value={selectedItem.short_name ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'short_name': e.target.value })} />
						</div>

						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('coefficient')}</label>
								<input type="number" className="form-control" name="coefficient"
									value={selectedItem.coefficient}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'coefficient': e.target.value })} />
							</div>

							<div className="position-relative w-100">
								<label>{t('color')}</label>
								<input type="text" className="form-control"
									placeholder={t('color')}
									value={selectedItem.color}
									onChange={(e) => handleInputChange('color', e.target.value)}
								/>
								<div className="color-picker-icon"
									style={{ 'backgroundColor': selectedItem.color, 'top': '60%' }}
									onClick={() => setSelectedItem({ ...selectedItem, 'color_bool': !selectedItem.color_bool })}
								/>
								{selectedItem.color_bool &&
									<div ref={colorRef}>
										<SketchPicker
											className="color-picker-body"
											onChangeComplete={handleChangeColor}
											color={selectedItem.color}
										/>
									</div>
								}
							</div>
						</div>

						<div className="d-flex gap-2">
							<div className="form-check p-0">
								<div className="radio-round"
									onClick={() => setSelectedItem({ ...selectedItem, 'is_present': true })}
									style={{ 'backgroundColor': selectedItem.is_present === true ? 'black' : '' }}>
								</div>
								<span onClick={() => setSelectedItem({ ...selectedItem, 'is_present': true })}>
									{t('attendance')}
								</span>
							</div>

							<div className="form-check p-0">
								<div className="radio-round"
									onClick={() => setSelectedItem({ ...selectedItem, 'is_present': false })}
									style={{ 'backgroundColor': selectedItem.is_present === false ? 'black' : '' }}>
								</div>
								<span onClick={() => setSelectedItem({ ...selectedItem, 'is_present': false })}>
									{t('no_attendance')}
								</span>
							</div>
						</div>

						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index